export enum TEST_NET_ID {
  BASE = 8453,
  SEPOLIA = 11155111,
  BSC_TEST = 97,
  BSC_MAIN = 56,
  ARBITRUM = 42161,
  POLYGON = 137,
  ETHEREUM = 1,
}

export enum TOKEN_SYMBOL {
  USDC = "0x833589fcd6edb6e08f4c7c32d4f71b54bda02913",
}

export enum MethodResponse {
  DEPOSIT = "Deposit",
  WITHDRAW = "Withdraw",
  TRANSFER = "Distributed",
  REBALANCE = "Rebalance",
  REF_TRANSFER = "ReferralTransfer",
}

export enum DEFAULT_ADDRESS {
  DEFAULT = "0x0000000000000000000000000000000000000000"
}

export enum MethodTransaction {
  DEPOSIT = "Deposit",
  WITHDRAW = "Withdraw",
  TRANSFER = "Distributed",
  REBALANCE = "Rebalance",
  REF_TRANSFER = "Referral Transfer",
}

export enum VaultOptions {
  ASSETS = "dashboard.chart.assets",
  APR = "dashboard.chart.apr",
  REWARDS = "dashboard.chart.rewards",
}

export enum Tab {
  OVERVIEW = "overview",
  REFERRAL = "referral",
  MP = "mpoint",
}

export enum TabMapping {
  VAULT = "common.vault",
  APR = "common.apr",
  TVL = "common.tvl",
  EARNINGS = "common.earnings",
}

export enum TimePeriod {
  WEEKLY = "weekly",
  MONTHLY = "monthly",
  YEARLY = "yearly",
}

export enum CommissionOptions {
  COMMISSIONS = "Commissions",
  REFERRALS = "Referrals",
}

export enum DepositStep {
  DEPOSIT = "Deposit",
  APPROVE = "Approve",
  CONFIRM = "Confirm",
  SUCCESS = "Success",
}